import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import ComponentsLibrary from '@/components/ComponentsLibrary'

// Admin-only area. Gated on the `admin` flag from the `me` query (set with
// `bin/rails admin:grant[email]`). Currently hosts the components library.
export default function AdminPage() {
  const { user, isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return (
      <main className="mx-auto max-w-3xl px-6 py-12">
        <p className="text-sm text-gray-500">Loading…</p>
      </main>
    )
  }

  if (!isAuthenticated || !user?.admin) {
    return (
      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="text-2xl font-bold tracking-tight">Admin</h1>
        <p className="mt-4 text-sm text-gray-500">
          You don’t have access to this page.
        </p>
        <Link to="/" className="mt-4 inline-block text-sm text-primary-600 hover:underline">
          ← Back to editor
        </Link>
      </main>
    )
  }

  return (
    <main className="mx-auto max-w-4xl px-6 py-12">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Admin</h1>
          <p className="text-sm text-gray-500">Internal tools — components library</p>
        </div>
        <Link to="/" className="text-sm text-primary-600 hover:underline">
          ← Back to editor
        </Link>
      </div>

      <div className="mt-10">
        <ComponentsLibrary />
      </div>
    </main>
  )
}
